import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import OrderedUserComponent from "./OrderedUserComponent";
import DraftLeadUserComponent from "./DraftLeadUserComponent";

function MasterComponent({ allComponentData }) {
  const [key, setKey] = useState("draftAndLeadUserComponent");
  return (
    <div>
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
      >
        <Tab
          eventKey="draftAndLeadUserComponent"
          title="Draft & Lead User Component"
        >
          <DraftLeadUserComponent
            leadData={allComponentData?.draftAndLeadUserComponent}
          />
        </Tab>
        <Tab eventKey="orderedUserComponent" title="Ordered User Component">
          <OrderedUserComponent
            orderedData={allComponentData?.orderedUserComponent}
          />
        </Tab>
      </Tabs>
    </div>
  );
}

export default MasterComponent;
